<template>
  <div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="height"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'hazop-plan',
  props: {
    popupParam: {
      type: Object,
      default: () => ({

      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      editable: true,
      splitter: 5,
      tab: 'runInfo',
      tabItems: [
       { name: 'runInfo', icon: 'edit', label: '감사실행정보', component: () => import(`${'./runInfo.vue'}`) },
       { name: 'doc', icon: 'checklist', label: '관련자료', component: () => import(`${'./runDoc.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
